export const byCardTypeEmptyData = {
  summary: {
    transactions_count: 0,
    transactions_amount: 0,
    chargebacks_count: 0,
    chargebacks_amount: 0,
    chargebacks_count_without_us: 0,
    chargebacks_amount_without_us: 0,
    alerts_count: 0,
    alerts_amount: 0,
    chargeback_rate: 0.0,
    chargeback_rate_without_us: 0.0,
    prevention_rate: 0.0
  },
  result: [
    {
      card_type: "visa",
      transactions_count: 0,
      transactions_amount: 0,
      chargebacks_count: 0,
      chargebacks_amount: 0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0,
      wallets: [
        {
          wallet_type: "card",
          transactions_count: 0,
          transactions_amount: 0,
          chargebacks_count: 0,
          chargebacks_amount: 0,
          chargebacks_count_without_us: 0,
          chargebacks_amount_without_us: 0,
          alerts_count: 0,
          alerts_amount: 0.0,
          chargeback_rate: 0.0,
          chargeback_rate_without_us: 0.0,
          prevention_rate: 0.0
        }
      ]
    },
    {
      card_type: "mastercard",
      transactions_count: 0,
      transactions_amount: 0,
      chargebacks_count: 0,
      chargebacks_amount: 0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0,
      wallets: [
        {
          wallet_type: "link",
          transactions_count: 0,
          transactions_amount: 0,
          chargebacks_count: 0,
          chargebacks_amount: 0,
          chargebacks_count_without_us: 0,
          chargebacks_amount_without_us: 0,
          alerts_count: 0,
          alerts_amount: 0.0,
          chargeback_rate: 0.0,
          chargeback_rate_without_us: 0.0,
          prevention_rate: 0.0
        }
      ]
    },
    {
      card_type: "american express",
      transactions_count: 0,
      transactions_amount: 0,
      chargebacks_count: 0,
      chargebacks_amount: 0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0,
      wallets: [
        {
          wallet_type: "link",
          transactions_count: 0,
          transactions_amount: 0,
          chargebacks_count: 0,
          chargebacks_amount: 0,
          chargebacks_count_without_us: 0,
          chargebacks_amount_without_us: 0,
          alerts_count: 0,
          alerts_amount: 0.0,
          chargeback_rate: 0.0,
          chargeback_rate_without_us: 0.0,
          prevention_rate: 0.0
        }
      ]
    },
    {
      card_type: "discover",
      transactions_count: 0,
      transactions_amount: 0,
      chargebacks_count: 0,
      chargebacks_amount: 0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0
    },
    {
      card_type: "jcb",
      transactions_count: 0,
      transactions_amount: 0,
      chargebacks_count: 0,
      chargebacks_amount: 0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0
    },
    {
      card_type: "diners club international",
      transactions_count: 0,
      transactions_amount: 0,
      chargebacks_count: 0,
      chargebacks_amount: 0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0
    }
  ]
}

export const byCountryEmptyData = {
  summary: {
    transactions_count: 0,
    transactions_amount: 0.0,
    chargebacks_count: 0,
    chargebacks_amount: 0.0,
    chargebacks_count_without_us: 0,
    chargebacks_amount_without_us: 0.0,
    alerts_count: 0,
    alerts_amount: 0,
    chargeback_rate: 0.0,
    chargeback_rate_without_us: 0.0,
    prevention_rate: 0.0
  },
  result: [
    {
      country_code: "us",
      country: "United States",
      transactions_count: 0,
      transactions_amount: 0.0,
      chargebacks_count: 0,
      chargebacks_amount: 0.0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0.0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0
    },
    {
      country_code: "gb",
      country: "United Kingdom",
      transactions_count: 0,
      transactions_amount: 0.0,
      chargebacks_count: 0,
      chargebacks_amount: 0.0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0.0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0
    },
    {
      country_code: "ca",
      country: "Canada",
      transactions_count: 0,
      transactions_amount: 0.0,
      chargebacks_count: 0,
      chargebacks_amount: 0.0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0.0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0
    },
    {
      country_code: "au",
      country: "Australia",
      transactions_count: 0,
      transactions_amount: 0.0,
      chargebacks_count: 0,
      chargebacks_amount: 0.0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0.0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0
    },
    {
      country_code: "fr",
      country: "France",
      transactions_count: 0,
      transactions_amount: 0.0,
      chargebacks_count: 0,
      chargebacks_amount: 0.0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0.0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0
    }
  ]
}

export const byCountryComingSoonData = {
  summary: {
    transactions_count: 12840,
    transactions_amount: 1284000.0,
    chargebacks_count: 214,
    chargebacks_amount: 21400.0,
    chargebacks_count_without_us: 96,
    chargebacks_amount_without_us: 9600.0,
    alerts_count: 132,
    alerts_amount: 13200.0,
    chargeback_rate: 1.67,
    chargeback_rate_without_us: 0.75,
    prevention_rate: 61.68,
  },
  result: [
    {
      country_code: "us",
      country: "United States",
      transactions_count: 7420,
      transactions_amount: 742000.0,
      chargebacks_count: 118,
      chargebacks_amount: 11800.0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0.0,
      alerts_count: 74,
      alerts_amount: 7400.0,
      chargeback_rate: 1.59,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 62.71,
    },
    {
      country_code: "gb",
      country: "United Kingdom",
      transactions_count: 2140,
      transactions_amount: 214000.0,
      chargebacks_count: 42,
      chargebacks_amount: 4200.0,
      chargebacks_count_without_us: 42,
      chargebacks_amount_without_us: 4200.0,
      alerts_count: 26,
      alerts_amount: 2600.0,
      chargeback_rate: 1.96,
      chargeback_rate_without_us: 1.96,
      prevention_rate: 61.9,
    },
    {
      country_code: "ca",
      country: "Canada",
      transactions_count: 1560,
      transactions_amount: 156000.0,
      chargebacks_count: 28,
      chargebacks_amount: 2800.0,
      chargebacks_count_without_us: 28,
      chargebacks_amount_without_us: 2800.0,
      alerts_count: 18,
      alerts_amount: 1800.0,
      chargeback_rate: 1.79,
      chargeback_rate_without_us: 1.79,
      prevention_rate: 64.29,
    },
    {
      country_code: "au",
      country: "Australia",
      transactions_count: 980,
      transactions_amount: 98000.0,
      chargebacks_count: 16,
      chargebacks_amount: 1600.0,
      chargebacks_count_without_us: 16,
      chargebacks_amount_without_us: 1600.0,
      alerts_count: 9,
      alerts_amount: 900.0,
      chargeback_rate: 1.63,
      chargeback_rate_without_us: 1.63,
      prevention_rate: 56.25,
    },
    {
      country_code: "fr",
      country: "France",
      transactions_count: 740,
      transactions_amount: 74000.0,
      chargebacks_count: 10,
      chargebacks_amount: 1000.0,
      chargebacks_count_without_us: 10,
      chargebacks_amount_without_us: 1000.0,
      alerts_count: 5,
      alerts_amount: 500.0,
      chargeback_rate: 1.35,
      chargeback_rate_without_us: 1.35,
      prevention_rate: 50.0,
    },
  ],
};

export const byReasonCodeEmptyData = {
  count: 3,
  next: "",
  previous: null,
  other: {
    transactions_count: 0,
    transactions_amount: 0.0,
    chargebacks_count: 2,
    chargebacks_amount: 88.0,
    chargebacks_count_without_us: 2,
    chargebacks_amount_without_us: 88.0,
    alerts_count: 0,
    alerts_amount: 0,
    chargeback_rate: 0.0,
    chargeback_rate_without_us: 0.0,
    prevention_rate: 0.0
  },
  summary: {
    transactions_count: 0,
    transactions_amount: 0.0,
    chargebacks_count: 8,
    chargebacks_amount: 446.51,
    chargebacks_count_without_us: 8,
    chargebacks_amount_without_us: 446.51,
    alerts_count: 0,
    alerts_amount: 0,
    chargeback_rate: 0.0,
    chargeback_rate_without_us: 0.0,
    prevention_rate: 0.0
  },
  results: [
    {
      reason_code: "10.4",
      tooltip: ["Other fraud – card absent environment"],
      type: "Fraudulent",
      card_brand: "Visa",
      transactions_count: 0,
      transactions_amount: 0.0,
      chargebacks_count: 0,
      chargebacks_amount: 0.0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0.0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0
    },
    {
      reason_code: "13.3",
      tooltip: ["Not as described or defective merchandise or services"],
      type: "Product unacceptable",
      card_brand: "Visa",
      transactions_count: 0,
      transactions_amount: 0.0,
      chargebacks_count: 0,
      chargebacks_amount: 0.0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0.0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0
    },
    {
      reason_code: "4837",
      tooltip: ["No Cardholder Authorization"],
      type: "Fraudulent",
      card_brand: "Mastercard",
      transactions_count: 0,
      transactions_amount: 0.0,
      chargebacks_count: 0,
      chargebacks_amount: 0.0,
      chargebacks_count_without_us: 0,
      chargebacks_amount_without_us: 0.0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0.0,
      chargeback_rate_without_us: 0.0,
      prevention_rate: 0.0
    }
  ]
}

export const overviewEmptyData = {
  labels: [
    "2026-03-11",
    "2026-03-12",
    "2026-03-13",
    "2026-03-14",
    "2026-03-15",
    "2026-03-16",
    "2026-03-17",
    "2026-03-18",
    "2026-03-19",
    "2026-03-20",
    "2026-03-21",
    "2026-03-22",
    "2026-03-23",
    "2026-03-24",
    "2026-03-25",
    "2026-03-26",
    "2026-03-27",
    "2026-03-28",
    "2026-03-29",
    "2026-03-30",
    "2026-03-31",
    "2026-04-01",
    "2026-04-02",
    "2026-04-03",
    "2026-04-04",
    "2026-04-05",
    "2026-04-06",
    "2026-04-07",
    "2026-04-08",
    "2026-04-09",
    "2026-04-10"
  ],
  result: {
    without_us: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
    ],
    with_us: [
      3, 5, 7, 6, 8, 12, 15, 14, 18, 22, 25, 23, 20, 17, 15, 13, 11, 9, 8, 10, 12, 14, 16, 18, 17,
      15, 13, 10, 7, 5
    ]
  }
}

export const olympicEmptyData = {
  count: 8,
  next: "",
  previous: null,
  results: [
    {
      customer_name: "-",
      chargebacks_count: "-",
      alerts_count: "-",
      email: "-",
      sequence_number: 1
    },
    {
      customer_name: "-",
      chargebacks_count: "-",
      alerts_count: "-",
      email: "-",
      sequence_number: 2
    },
    {
      customer_name: "-",
      chargebacks_count: "-",
      alerts_count: "-",
      email: "-",
      sequence_number: 3
    },
    {
      customer_name: "-",
      chargebacks_count: "-",
      alerts_count: "-",
      email: "-",
      sequence_number: 4
    },
    {
      customer_name: "-",
      chargebacks_count: "-",
      alerts_count: "-",
      email: "-",
      sequence_number: 5
    },
    {
      customer_name: "-",
      chargebacks_count: "-",
      alerts_count: "-",
      email: "-",
      sequence_number: 6
    }
  ]
}

export const olympicComingSoonData = {
  count: 6,
  next: "",
  previous: null,
  results: [
    {
      customer_name: "Nawras Ganim",
      chargebacks_count: 922,
      alerts_count: 922,
      email: "nawras@chargeback.com",
      sequence_number: 1
    },
    {
      customer_name: "Josef Ganim",
      chargebacks_count: 922,
      alerts_count: 922,
      email: "josef@chargeback.com",
      sequence_number: 2
    }
  ]
}

export const preventionEmptyData = [
  {
    alerts_count: 0,
    disputes_count: 0,
    preventionRate: 0.0,
    month: "JAN"
  },
  {
    alerts_count: 0,
    disputes_count: 0,
    preventionRate: 0.0,
    month: "FEB"
  },
  {
    alerts_count: 0,
    disputes_count: 0,
    preventionRate: 0.0,
    month: "MAR"
  },
  {
    alerts_count: 0,
    disputes_count: 0,
    preventionRate: 0.0,
    month: "APR"
  },
  {
    alerts_count: 0,
    disputes_count: 0,
    preventionRate: 0.0,
    month: "MAY"
  },
  {
    alerts_count: 0,
    disputes_count: 0,
    preventionRate: 0.0,
    month: "JUN"
  },
  {
    alerts_count: 0,
    disputes_count: 0,
    preventionRate: 0.0,
    month: "JUL"
  },
  {
    alerts_count: 0,
    disputes_count: 0,
    preventionRate: 0.0,
    month: "AUG"
  },
  {
    alerts_count: 0,
    disputes_count: 0,
    preventionRate: 0.0,
    month: "SEP"
  },
  {
    alerts_count: 0,
    disputes_count: 0,
    preventionRate: 0.0,
    month: "OCT"
  },
  {
    alerts_count: 0,
    disputes_count: 0,
    preventionRate: 0.0,
    month: "NOV"
  },
  {
    alerts_count: 0,
    disputes_count: 0,
    preventionRate: 0.0,
    month: "DEC"
  }
]

export const processorsRiskEmptyData = { risk_level: 0 }
